import { FunctionComponent, ReactNode, useState } from 'react';
import { Divider, IconButton } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

interface AccordionSectionProps {
  children: ReactNode;
  title?: string;
  defaultExpanded?: boolean;
}

export const AccordionSection: FunctionComponent<AccordionSectionProps> = ({ children, title, defaultExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        {title && <span className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">{title}</span>}
        <Divider className="flex-1" />
        <IconButton
          onClick={handleToggle}
          size="small"
          className="transition-transform duration-300"
          style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
          tabIndex={-1}
        >
          <ExpandMore className="text-gray-400 dark:text-gray-500" />
        </IconButton>
      </div>

      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: isExpanded ? '1000px' : '0px',
          opacity: isExpanded ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};
